export default __webpack_public_path__ + "static/char-v-06-9266aed7bc7462e3f3c6365db99a058d.webp";